import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, ToastController, ModalController, AlertController } from 'ionic-angular';
import { ProjectCategoryModel } from '../../model/CronosModel';
import { CronosService } from './../../services/CronosService';
import { CronosCategoryFormPage } from './../cronos-category-form/cronos-category-form';

@IonicPage()
@Component({
  selector: 'page-cronos-categories',
  templateUrl: 'cronos-categories.html',
})
export class CronosCategoriesPage {

  public searchInput: string;
  public shouldShowCancelSearch: boolean;
  public allCategories: Array<ProjectCategoryModel>;
  public filteredCategories: Array<ProjectCategoryModel>;
  public originalCategories: Array<ProjectCategoryModel>;
  public categories: Array<ProjectCategoryModel>;
  public boardId: number;
  public clientId: number;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public viewCtrl: ViewController,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private cronosService: CronosService
  ) {
    this.originalCategories = this.navParams.get('categories');
    this.categories = this.originalCategories.map(x => Object.assign({}, x));
    this.boardId = this.navParams.get('boardId');
    this.clientId = this.navParams.get('clientId');
  }

  ionViewDidLoad() {
    this.listCategories();
  }

  listCategories() {
    this.cronosService.listCategories(this.boardId).subscribe(
      data => {
        this.allCategories = data;
        this.search();
      },
      err => {
        this.presentToast('Houve um erro ao listar as categorias do projeto');
      }
    )
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });  
    toast.present();
  }

  search() {
    this.filteredCategories = this.allCategories;
    if (this.searchInput != null && this.searchInput != '') {
      this.filteredCategories = this.allCategories.filter(x => x.name.indexOf(this.searchInput) >= 0);
    }
  }

  cancelSearch() {
    this.searchInput = null;
    this.shouldShowCancelSearch = false;
    this.search();
  }

  isCategory(category: ProjectCategoryModel) {
    if (this.categories.length == 0) {
      return false;
    } else {
      return this.categories.find(x => x.id == category.id) != null;
    }
  }

  changeCategory(category: ProjectCategoryModel) {
    if (this.isCategory(category)) {
      let idx = this.categories.findIndex(x => x.id == category.id);
      if (idx != null) {
        this.categories.splice(idx, 1);
      }
    } else {
      if (!this.categories) {
        this.categories = new Array<ProjectCategoryModel>();
      }
      this.categories.push({
        boardId: this.boardId,
        clientId: category.clientId,
        color: category.color,
        id: category.id,
        name: category.name
      });
    }
  }

  cancel() {
    this.viewCtrl.dismiss(this.originalCategories);
  }

  confirm() {
    this.viewCtrl.dismiss(this.categories);
  }

  addCategory() {
    const modal = this.modalCtrl.create(CronosCategoryFormPage, { boardId: this.boardId, clientId: this.clientId }, { showBackdrop: true });
    modal.onDidDismiss(() => {
      this.listCategories();
    });
    modal.present();
  }

  editCategory(category: ProjectCategoryModel) {
    const modal = this.modalCtrl.create(CronosCategoryFormPage, { boardId: this.boardId, clientId: this.clientId, category }, { showBackdrop: true });
    modal.onDidDismiss(() => {
      this.listCategories();
    });
    modal.present();
  }

  removeCategory(id: number) {
    const confirm = this.alertCtrl.create({
      title: 'Confirma Exclusão',
      buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Confirmar',
          handler: () => {
            this.cronosService.removeCategory(id).subscribe(
              data => {
                this.presentToast('Categoria removida com sucesso');
                this.listCategories();
              },
              err => {
                this.presentToast('Houve um erro ao remover a categoria');
              }
            );
          }
        }
      ]
    });
    confirm.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/cronos-categories/cronos-categories.ts